import { z } from 'zod';
import { grammarItemSchema } from '../grammar-item-schema';

const grammarItemResponseSchemaDefinition = z.intersection(
  z.object({
    id: z.number().int(),
    pointId: z.number().int(),
  }),
  grammarItemSchema,
);

export const grammarItemResponseSchema: typeof grammarItemResponseSchemaDefinition =
  grammarItemResponseSchemaDefinition;

export type IGrammarItemResponse = z.infer<typeof grammarItemResponseSchema>;
